export const subFiltersConfig = {
  basura: [
    { id: 'bolsas_rotas', label: 'Bolsas Rotas' },
    { id: 'acumulacion', label: 'Acumulación' },
    { id: 'animal_muerto', label: 'Animal Muerto' },
    { id: 'bolsas', label: 'Bolsas' },
    { id: 'escombro', label: 'Escombros' },
    { id: 'neumatico', label: 'Neumático' },
    { id: 'voluminoso', label: 'Voluminoso' }
  ],
  arbol: [
    { id: 'poda', label: 'Poda' },
    { id: 'altura', label: 'Altura' }
  ],
  sen_horiz: [
    { id: 'lineas', label: 'Líneas' },
    { id: 'simbolos', label: 'Símbolos' },
    { id: 'sendas', label: 'Sendas' }
  ]
};
